import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

const sanitise = ({id, courseId, ...module}) => ({
    id:         Number(id),
    courseId:   Number(courseId),
    ...module
});

let _courseModules = [];

let CourseModuleStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getModule: function(courseId, moduleId) {
        return _courseModules.find(({id, courseId}) => id === moduleId && courseId === courseId);
    },
    getModules: function(courseId) {
        return _courseModules
            .filter((m) => m !== undefined && m.courseId === courseId)
            .sort((a,b) => a.listOrder - b.listOrder);
    },
    addModule: function(module) {
        let moduleIndex = _courseModules
            .findIndex((e) => e !== undefined && e.id === module.id && e.courseId === module.courseId);
        if ( 0 > moduleIndex ) {
            _courseModules.push(module);
        } else {
            _courseModules[moduleIndex] = module; // update data
        }
    },
    addModules: function(modules) {
        if (modules instanceof Array) {
            modules.forEach(this.addModule);
        } else {
            this.addModule(modules);
        }
    },
    deleteModule: function(data) {
        let moduleIndex = _courseModules
            .findIndex(function(e){ return e !== undefined && e.id == data.moduleId && e.courseId == data.courseId; } );
        if (moduleIndex >= 0) {
            if (data.deleted) {
                delete _courseModules[moduleIndex];
            } else {
                _courseModules[moduleIndex].loading = false;
            }
        }
    },
});

CourseModuleStore.dispatchToken = CentricDispatcher.register(function(action) {
    let modules;
    switch (action.type) {
        case ActionTypes.COURSE_MODULE_INFO_SUCCESS:
            CourseModuleStore.addModule(sanitise(action.data));
            CourseModuleStore.emitChange();
            break;

        case ActionTypes.COURSE_MODULE_LIST:
            modules = action.data.map(sanitise);
            CourseModuleStore.addModules(modules);
            CourseModuleStore.emitChange();
            break;
            
        case ActionTypes.COURSE_MODULE_SAVE:
            CourseModuleStore.addModule(sanitise(action.data));
            CourseModuleStore.emitChange();
            break;
            
        case ActionTypes.COURSE_MODULE_SAVE_ERROR:
            CourseModuleStore.emitChange();
            break;
            
        case ActionTypes.COURSE_MODULE_UPDATE:
            CourseModuleStore.addModule(sanitise(action.data));
            CourseModuleStore.emitChange();
            break;

        case ActionTypes.COURSE_MODULE_UPDATE_ERROR:
            CourseModuleStore.emitChange();
            break;

        case ActionTypes.COURSE_MODULE_DELETE:
            CourseModuleStore.deleteModule(action.data);
            CourseModuleStore.emitChange();
            break;

        case ActionTypes.COURSE_MODULE_MOVE_UP_SUCCESS:
            modules = action.data.map(sanitise);
            CourseModuleStore.addModules(modules);
            CourseModuleStore.emitChange();
            break;
        default:
            break;
    }
});

export default CourseModuleStore;
